import {FinOptsys} from '../FinOptSys/FinOptSys'

export const TradeUp = {
	...FinOptsys,
	id: 'tradeUp',
}
